import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  allEntitySelector,
  entityByIdSelector
} from "../../../reducers/entity";
import { fetchEntities } from "../../../actions/entities";
import {allProps, endpointFindAll, prop, propDisplay, propId} from "../../../utils/metaUtil";
import {allMetaSelector} from "../../../reducers/meta";

class EntityListPage extends React.Component {
  componentDidMount = () => this.onInit(this.props);

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.match.params.entityType !== this.props.match.params.entityType
    ) {
      this.onInit(nextProps);
    }
  }
    onInit = props => {
        const entityType = props.match.params.entityType;
        props.fetchEntities(
            entityType,
            endpointFindAll(props.meta, entityType)
        );
    };
  truncValue = (value) => {
    if (value && (typeof value==='string' || value instanceof String)) {
      return value.substr(0, 100);
    } else {
      return value;
    }
  };
  renderProperty = (meta, entity, propKey) => {
    const entityType = this.props.match.params.entityType;
    const property = prop(meta, entityType, propKey);
    if (property.visible === false) return;
    const id = propId(meta, entityType);
    const key = `${entity[id]}_${propKey}`;
    if (property.type) {
      return (
        <td key={key}>
          <Link to={`/entity/${entityType}/${entity[id]}`}>
            {this.truncValue(entity[propKey])}
          </Link>
        </td>
      );
    } else {
      const refEntity = entityByIdSelector(
        this.props.state,
        propKey,
        entity[propKey]
      );
      return (
        <td key={key}>
            {refEntity && (<Link to={`/entity/${entityType}/${entity[id]}`}>
            {refEntity[propDisplay(meta, propKey)]}
          </Link>)}
        </td>
      );
    }
  };
  renderEntity = (meta, entity) => {
    const entityType = this.props.match.params.entityType;
    return (
      <tr>
        {Object.keys(allProps(meta, entityType)).map(e => {
          return this.renderProperty(meta, entity, e);
        })}
      </tr>
    );
  };

  render() {
    const { entities, meta } = this.props;

    const entityType = this.props.match.params.entityType;
    return (
      <div className="container mt-3">
        <div className="row">
          <div className="col-6">
            <h1>List - {entityType}</h1>
          </div>
          <div className="col-6 text-right">

              <Link to={`/entity/${entityType}/create`}>
            <button className="btn btn-primary btn-lg">NEW</button>
              </Link>
          </div>
        </div>
        {entities &&
          entities.length !== 0 && (
            <div className="table-responsive-sm">
              <table className="table table-hover">
                <thead className="thead-dark">
                  <tr>
                    {Object.keys(allProps(meta, entityType)).map(e => {
                      const display = prop(meta, entityType, e).display
                        ? prop(meta, entityType, e).display
                        : e;
                      if (prop(meta, entityType, e).visible!==false) {
                          return (
                              <th key={`heading_${e}`} scope="col">
                                  {display}
                              </th>
                          );
                      }
                    })}
                  </tr>
                </thead>
                {entities.map(entity => {
                  return (
                    <tbody>{this.renderEntity(meta, entity)}</tbody>
                    // <Link to={`/entity/${entityType}/${entity.id}`}>
                  );
                })}
              </table>
            </div>
          )}
      </div>
    );
  }
}

EntityListPage.propTypes = {
  fetchEntities: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      entityType: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  entities: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  state: PropTypes.shape().isRequired
};
EntityListPage.defaultProps = {};

function mapStateToProps(state, props) {
  return {
    entities: allEntitySelector(state, props.match.params.entityType),
    state,
    meta: allMetaSelector(state)
  };
}

export default connect(mapStateToProps, { fetchEntities })(EntityListPage);



// WEBPACK FOOTER //
// ./src/components/pages/entitylist/EntityListPage.js